module.exports = __webpack_public_path__ + "media/application/images/icons/print-solid-white-90af77992b9844fae0b8c811372e07b3.svg";